import React from 'react';
import styles from "./mapSection.module.sass"
import line from "../../assets/Line 16.png"
import { YMaps, Map, Placemark, SearchControl, ZoomControl } from '@pbe/react-yandex-maps';

export const MapSection = () => {

    const ButtonClick = () => {
        let button = document.querySelector('.ymaps-2-1-79-_hidden-icon') as HTMLButtonElement;
        button.click()
    }

    const LocationMove = (id: string) => {
        if (window.innerWidth < 851 && window.innerWidth > 463) {
            let map_id = document.getElementById('mapHidden')
            if (map_id !== null) {
                let child = map_id.children[0]
                let child1 = child.children[0]
                let child2 = child1.children[0]
                let child3 = child2.children[0]
                let child4 = child3.children[3]
                let child5 = child4.children[0]
                let child6 = child5.children[1]
                let child7 = child6.children[0]
                let child8 = child7.children[0]
                let child9 = child8.children[0]
                let child10 = child9.children[0]
                let child11 = child10.children[0]
                let child12 = child11.children[0]
                let child13 = child12.children[0]
                let child14 = child13.children[0]
                let child15 = child14.children[0]
                let child16 = child15.children[0]
                let childbutton1 = child14.children[1]
                let hidden_map_button = childbutton1.children[0]
                let hidden_map_input = child16.children[0]
                let element = document.getElementById(id);
                let searchInput = hidden_map_input as HTMLInputElement
                let searchButton = hidden_map_button as HTMLInputElement;
                if (element == null || searchButton == null || searchInput == null) {
                } else {
                    let data = element.textContent;
                    if (data == null) {
                        console.log('X_O1 data error')
                    } else {
                        searchInput.value = data
                        searchButton.click()
                    }
                }
            }
        } if (window.innerWidth < 463) {
            ButtonClick()
            let map_id = document.getElementById('mapHidden')
            if (map_id !== null) {
                let child = map_id.children[0]
                let child1 = child.children[0]
                let child2 = child1.children[0]
                let child3 = child2.children[0]
                let child4 = child3.children[4]
                let child5 = child4.children[0]
                let child6 = child5.children[0]
                let child7 = child6.children[0]
                let child8 = child7.children[0]
                let child9 = child8.children[0]
                let child10 = child9.children[0]
                let child11 = child10.children[0]
                let hidden_map_input_small = child11.children[0]
                let button1 = child9.children[1]
                let hidden_map_button_small = button1.children[0]
                let element = document.getElementById(id);

                let searchInput = hidden_map_input_small as HTMLInputElement
                let searchButton = hidden_map_button_small as HTMLButtonElement;
                if (element == null || searchButton == null || searchInput == null) {
                } else {
                    let data = element.textContent;
                    if (data == null) {
                        console.log('X_O1 data error')
                    } else {
                        searchInput.value = data
                        searchButton.click()
                    }
                }
            }

        }
        if (window.innerWidth > 851) {
            let element = document.getElementById(id);
            let searchButton = document.querySelector('.ymaps-2-1-79-searchbox-button') as HTMLButtonElement;
            let searchInput = document.querySelector('.ymaps-2-1-79-searchbox-input__input') as HTMLInputElement;
            if (element == null || searchButton == null || searchInput == null) {
                console.log(' X_00 data error')
            } else {
                let data = element.textContent;
                if (data == null) {
                    console.log('X_O1 data error')
                } else {
                    searchInput.value = data
                    searchButton.click()
                }
            }
        }
    }
    return (
        <div className={styles.section__map__wrap} id="sectionMap">
            <div className={styles.section__map__headerWrap}>
                <span className={styles.section__map__header}>Найдите нас в своем городе </span>
            </div>
            <img className={styles.section__map__lineImg} src={line} alt=""/>
            <div className={styles.section__map__rowWrap}>
                <div className={styles.section__map__rectangle}></div>
                <div className={styles.section__map__column2}>
                    <div className={styles.section__map__columnHeaderWrap}>
                        <h1 id='adressHeader1' className={styles.section__map__columnHeader}>Казань</h1>
                        <img className={styles.section__map__columnHeaderLine} src={line} alt=""/>
                    </div>
                    <button id='adressButton1' onClick={() => LocationMove('button-1')} className={styles.section__map__column2Button}>
                        <span  id='button-1' className={styles.section__map__column2Text}>Проспект Ямашева, 69</span>
                        <img className={styles.section__map__smallLine} src={line} alt=""/>
                        <span>Казань</span>
                    </button>
                    <button id='adressButton2'  onClick={() => LocationMove('button-2')} className={styles.section__map__column2Button}>
                        <span id='button-2' className={styles.section__map__column2Text}>Улица Первомайская, 33</span>
                        <img className={styles.section__map__smallLine} src={line} alt=""/>
                        <span>Уфа</span>
                    </button>
                    <button id='adressButton3'  onClick={() => LocationMove('button-3')} className={styles.section__map__column2Button}>
                        <span id='button-3' className={styles.section__map__column2Text}>50-летия Октября, 7</span>
                        <img className={styles.section__map__smallLine} src={line} alt=""/>
                        <span>Уфа</span>
                    </button>
                </div>
                <div className={styles.section__map__column2Hidden}>
                    <div className={styles.section__map__columnHeaderWrap}>
                        <h1 id='adressHeader2' className={styles.section__map__columnHeader}>Казань</h1>
                        <img className={styles.section__map__columnHeaderLine} src={line} alt=""/>
                    </div>
                    <div className={styles.section__map__hiddenButtonRow}>
                        <button id='adressButton4' onClick={() => LocationMove('button-4')} className={styles.section__map__column2Button}>
                            <span id='button-4' className={styles.section__map__column2Text}>Проспект Ямашева, 69</span>
                            <img className={styles.section__map__smallLine} src={line} alt=""/>
                            <span>Казань</span>
                        </button>
                        <button id='adressButton5'  onClick={() => LocationMove('button-5')} className={styles.section__map__column2Button}>
                            <span id='button-5' className={styles.section__map__column2Text}>Улица Первомайская, 33</span>
                            <img className={styles.section__map__smallLine} src={line} alt=""/>
                            <span>Уфа</span>
                        </button>
                        <button id='adressButton6'  onClick={() => LocationMove('button-6')} className={styles.section__map__column2Button}>
                            <span id='button-6' className={styles.section__map__column2Text}>50-летия Октября, 7</span>
                            <img className={styles.section__map__smallLine} src={line} alt=""/>
                            <span>Уфа</span>
                        </button>
                    </div>
                </div>
                <YMaps>
                    <div className={styles.section__map__yandexMapWrap} id='map'>
                        <Map
                            width={1000}
                            height={800}
                            defaultState={{ center: [54.736112, 55.961330], zoom: 15 }}>
                            <Placemark geometry={[54.736112, 55.961330]} />
                            <SearchControl options={{ float: "right" }} />
                            <ZoomControl options={{ position: {top: 300, left: 20}}} />
                        </Map>
                    </div>
                    <div className={styles.section__map__yandexMapWrapHidden} id='mapHidden'>
                        <Map
                             width={1000}
                             height={500}
                             defaultState={{ center: [54.736112, 55.961330], zoom: 15 }}>
                            <Placemark geometry={[54.736112, 55.961330]} />
                            <SearchControl options={{ float: "right" }} />
                            <ZoomControl options={{ position: {top: 300, left: 20}}} />
                        </Map>
                    </div>
                </YMaps>
            </div>

        </div>
    );
};
